import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "clearfix" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["width", "height", "src"]
const _hoisted_4 = { class: "kanren-t" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock-o" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("dl", _hoisted_1, [
    _createElementVNode("dt", null, [
      _createElementVNode("a", { href: _ctx.link }, [
        _createElementVNode("img", {
          width: _ctx.imgWidth,
          height: _ctx.imgHeight,
          src: _ctx.thumbnailUrl,
          class: "attachment-full size-full wp-post-image",
          alt: ""
        }, null, 8, _hoisted_3)
      ], 8, _hoisted_2)
    ]),
    _createElementVNode("dd", null, [
      _createElementVNode("h5", _hoisted_4, [
        _createElementVNode("a", { href: _ctx.link }, _toDisplayString(_ctx.title), 9, _hoisted_5)
      ]),
      _hoisted_6,
      _createTextVNode(" " + _toDisplayString(_ctx.createdAt), 1)
    ])
  ]))
}